// extracted by mini-css-extract-plugin
export default {"links":"DesktopNavigationMenu_links__CZEp0","usurpation":"DesktopNavigationMenu_usurpation__Z1DM2"};